/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PutProjectNavModeRequestBody = OperationRequestBodyContent<operations['putProjectNavMode']>;

export interface Input {
  apiVersion?: string;
  body: PutProjectNavModeRequestBody;
}

export async function putProjectNavMode(
  { apiVersion, body }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PUT('/internal/profile/project-nav-mode', {
    params: {},
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
